import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4FCD7DBE-6B4C-41DB-BDD8-40ED820EC7F1
 * name camera-burst
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-burst.svg
 * tags
 * - Photography 
 */
export const CameraBurstIcon = createSvgIcon(<><path d="M1,5H3V19H1V5M5,5H7V19H5V5M22,5H10A1,1 0 0,0 9,6V18A1,1 0 0,0 10,19H22A1,1 0 0,0 23,18V6A1,1 0 0,0 22,5M11,17L13.5,13.85L15.29,16L17.79,12.78L21,17H11Z" /></>, 'CameraBurstIcon');
export default CameraBurstIcon